export function clipOverlaySegmentToBox(start, end, chartWidth, chartHeight) {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    let t0 = 0;
    let t1 = 1;
    const edges = [
        [-dx, start.x],
        [dx, chartWidth - start.x],
        [-dy, start.y],
        [dy, chartHeight - start.y],
    ];
    for (const [p, q] of edges) {
        if (p === 0) {
            if (q < 0) {
                return null;
            }
            continue;
        }
        const r = q / p;
        if (p < 0) {
            if (r > t1) {
                return null;
            }
            if (r > t0) {
                t0 = r;
            }
        }
        else {
            if (r < t0) {
                return null;
            }
            if (r < t1) {
                t1 = r;
            }
        }
    }
    if (t1 < t0) {
        return null;
    }
    return [
        { x: start.x + dx * t0, y: start.y + dy * t0 },
        { x: start.x + dx * t1, y: start.y + dy * t1 },
    ];
}
/**
 * @deprecated T-5A: kept for backwards compatibility only. The renderer
 * (drawCallout → drawTextBoxBackground) and hit-test both use
 * computeTextBoxLayout with style.textBoxWidth/Height, so this text-length
 * estimate diverges after a box resize. Do not use for new code.
 */
export function measureOverlayCalloutBox(anchor, text, fontSize = 12) {
    const label = text?.trim().length ? text : "Text";
    const paddingX = 8;
    const paddingY = 6;
    const width = Math.max(fontSize * 2.6, label.length * fontSize * 0.58 + paddingX * 2);
    const height = fontSize + paddingY * 2;
    return {
        x: anchor.x - width / 2,
        y: anchor.y - height / 2,
        width,
        height,
        text: label,
    };
}
function triangleSign(point, a, b) {
    return (point.x - b.x) * (a.y - b.y) - (a.x - b.x) * (point.y - b.y);
}
export function pointInOverlayTriangle(point, a, b, c) {
    const d1 = triangleSign(point, a, b);
    const d2 = triangleSign(point, b, c);
    const d3 = triangleSign(point, c, a);
    const hasNegative = d1 < 0 || d2 < 0 || d3 < 0;
    const hasPositive = d1 > 0 || d2 > 0 || d3 > 0;
    return !(hasNegative && hasPositive);
}
/** Right-edge price tags never grow past this width — longer labels truncate with "…". */
export const OVERLAY_PRICE_TAG_MAX_WIDTH = 160;
const APPROX_CHAR_WIDTH = 0.58;
export function measureOverlayPriceLabelTag(chartWidth, text, fontSize = 11) {
    const raw = text?.trim().length ? text : "Price";
    const paddingX = 6;
    const paddingY = 4;
    const height = fontSize + paddingY * 2;
    const naturalWidth = Math.max(fontSize * 3, raw.length * fontSize * APPROX_CHAR_WIDTH + paddingX * 2);
    if (naturalWidth <= OVERLAY_PRICE_TAG_MAX_WIDTH) {
        return {
            x: chartWidth - naturalWidth - 2,
            width: naturalWidth,
            height,
            text: raw,
        };
    }
    // T-5B: truncate with an ellipsis so long labels cannot cover the chart.
    // Renderer and hit-test both consume this measure, so they stay in sync.
    const textBudget = OVERLAY_PRICE_TAG_MAX_WIDTH - paddingX * 2;
    const maxChars = Math.max(1, Math.floor(textBudget / (fontSize * APPROX_CHAR_WIDTH)));
    const label = `${raw.slice(0, maxChars).trimEnd()}…`;
    return {
        x: chartWidth - OVERLAY_PRICE_TAG_MAX_WIDTH - 2,
        width: OVERLAY_PRICE_TAG_MAX_WIDTH,
        height,
        text: label,
    };
}
